import React from 'react';
import { Layout, Col, Row, Card, Steps, Typography, List, BackTop } from 'antd';
import {
  UserOutlined,
  SolutionOutlined,
  WalletOutlined,
  SmileTwoTone
} from '@ant-design/icons';

import 'antd/dist/antd.css';
import '../assets/css/cart.css';

import GetTitle from '../components/Cart/GetTitle';
import AccountDescription from '../components/Cart/AccountDescription';
import CheckoutListItems from '../components/Cart/CheckoutListItems';
import DeliveryAddressDescription from '../components/Cart/DeliveryAddressDescription';
import PaymentDescription from '../components/Cart/PaymentDescription';

import UseWindowSize from '../hooks/UseWindowSize';

const { Title, Text, Paragraph } = Typography;
const data = [
  { key: '0', name: 'Pizza', amount: 500 },
  { key: '1', name: 'Manchao Soup', amount: 100 },
  { key: '2', name: 'Cold coffee', amount: 200 },
  { key: '3', name: 'Watermelon Juice', amount: 200 },
  { key: '4', name: 'Cheese burger', amount: 1500 }
];

const CheckoutTitle = () => {
  return (
    <div>
      <SmileTwoTone /> Complete Order
    </div>
  );
};

const CartPage = () => {
  const { Content } = Layout;
  const { Step } = Steps;
  const { width } = UseWindowSize() || {};
  const deviceType =
    // @ts-ignore
    width < 768 ? 'mobile' : width >= 768 && width < 1024 ? 'tab' : 'desktop';

  const headerStyle = deviceType === 'mobile' ? { padding: 15 } : {};
  const bodyStyle = deviceType === 'mobile' ? { padding: 15 } : {};

  return (
    <div>
      <Layout>
        <Content className="site-layout">
          <Row className="cartRow" gutter={[16, 16]}>
            <Col xs={24} sm={15} md={15} lg={15} xl={15} xxl={15}>
              <Card
                title={<GetTitle />}
                bordered={true}
                headStyle={{ ...headerStyle }}
                bodyStyle={{ ...bodyStyle }}
              >
                <Steps current={1} direction="vertical">
                  <Step
                    status="finish"
                    title="Account"
                    icon={<UserOutlined />}
                    description={<AccountDescription />}
                  />

                  <Step
                    status="finish"
                    title="Delivery Address"
                    icon={<SolutionOutlined />}
                    description={<DeliveryAddressDescription />}
                  />
                  <Step
                    status="finish"
                    title="Payment"
                    icon={<WalletOutlined />}
                    description={<PaymentDescription />}
                  />
                </Steps>
              </Card>
            </Col>
            <Col
              xs={{ span: 24 }}
              sm={{ span: 8, offset: 1 }}
              md={{ span: 8, offset: 1 }}
              lg={{ span: 8, offset: 1 }}
              xl={{ span: 8, offset: 1 }}
              xxl={{ span: 8, offset: 1 }}
            >
              <Card title={<CheckoutTitle />} bordered={true}>
                <div style={{ height: 100, overflowY: 'scroll' }}>
                  <List
                    size="small"
                    header={
                      <div>
                        <Text strong>Pizza Hut</Text>
                      </div>
                    }
                    dataSource={data}
                    renderItem={(item) => <CheckoutListItems {...item} />}
                  />
                </div>
                <div style={{ display: 'flex' }}>
                  <div style={{ flex: '3 0 0' }}>
                    <Text strong>TO PAY</Text>
                  </div>
                  <div style={{ flex: '1 0 0' }}>
                    <Text strong>318</Text>
                  </div>
                </div>
              </Card>
              <Card bordered={true} style={{ marginTop: 16 }}>
                <Title level={4}>
                  Please make sure your order and address details should be
                  correct
                </Title>
                <br />
                <Paragraph>
                  Note: Delivery guy will ask the OTP, please confirm that at
                  the time of delivery.
                </Paragraph>
              </Card>
            </Col>
          </Row>
          <BackTop />
        </Content>
      </Layout>
    </div>
  );
};

export default CartPage;
